var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUser2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7456 14.0885V12.7467C12.7456 12.035 12.4629 11.3525 11.9596 10.8492C11.4564 10.3459 10.7738 10.0632 10.0621 10.0632H6.0368C5.32509 10.0632 4.64252 10.3459 4.13926 10.8492C3.636 11.3525 3.35327 12.035 3.35327 12.7467V14.0885",
    stroke: "#99A1AF",
    strokeWidth: 1.34177,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04938 7.37967C9.53145 7.37967 10.7329 6.17821 10.7329 4.69614C10.7329 3.21406 9.53145 2.0126 8.04938 2.0126C6.5673 2.0126 5.36584 3.21406 5.36584 4.69614C5.36584 6.17821 6.5673 7.37967 8.04938 7.37967Z",
    stroke: "#99A1AF",
    strokeWidth: 1.34177,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser2);
export default __webpack_public_path__ + "static/media/icon_user2.46c16e3734cd741905fb0dcd5636acba.svg";
export { ForwardRef as ReactComponent };